/**
 * @file order-business-status.tsx
 * @module app/modules/_common/components/order-business-status
 * @description Reusable status-span group for Orders Delivery pane tables. Consolidates the
 * move-to-pending / scheduled-for-next-day / new-customer-priority status spans into a single
 * component so every pane (New Orders, In Progress, etc.) renders these statuses consistently
 * instead of duplicating the same markup and logic per pane.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.1
 * @version 1.3.1
 */

import Method from '../../../../utils/methods';
import { RouteOrderMovedToPendingOrder } from '../../../../utils/constants';
import MoveToPendingSpan from './move-to-pending-span';
import { ScheduleForNextDaySpan } from './schedule-for-next-day-span';
import { NewCustomerPriorityOrderSpan } from './new-order-span';
import { PartialDeliverSpan } from './partial-deliver-span';

interface OrderBusinessStatusProps {
  orderVal: any;
  isNewOrder?: number;
}

const MoveToPendingMarker = ({ orderVal, className }: any) => {
  return (
    <>
      {orderVal.latestRouteVehicle?.status ===
      RouteOrderMovedToPendingOrder ? (
        <MoveToPendingSpan
          className={`${className || ''}`}
          msg={Method.convertDateToDDMMYYYYHOURS(
            orderVal.latestRouteVehicle.statusUpdatedAt
          )}
        />
      ) : (
        <></>
      )}
    </>
  );
};

const OrderBusinessStatus: React.FC<OrderBusinessStatusProps> = ({
  orderVal,
  isNewOrder,
}) => {
  return (
    <span className="margin-top-5">
      <PartialDeliverSpan orderVal={orderVal} />
      {isNewOrder !== undefined && (
        <NewCustomerPriorityOrderSpan isNewOrder={isNewOrder} className='padding-left-0' />
      )}
      {orderVal.latestRouteVehicle?.status === RouteOrderMovedToPendingOrder && (
        <>
          {orderVal.latestRouteVehicle.scheduleNextDelivery ? (
            <ScheduleForNextDaySpan className='padding-left-0' />
          ) : (
            <MoveToPendingMarker orderVal={orderVal} className='padding-left-0' />
          )}
        </>
      )}
    </span>
  );
};

export default OrderBusinessStatus;
